/* m.i.b Produktseite (Julia, Auftrag Sebastian 06.10./07.10.2026, visuell 08.10.2026)
   Unter dem Titel: kurze Einleitung (fette Kopfzeile + 1 Satz), der Rest bleibt im Reiter Beschreibung.
   "Auf einen Blick": 3-6 Kacheln mit Icon, Wert und Wort, nur Werte, die eindeutig im Text stehen (sonst keine Kachel).
   PC rechts unter der Einleitung, Handy unter dem Warenkorb-Knopf (Knopf rueckt nicht nach unten).
   Reiter "Produktbeschreibung | Technik | Download": Handy unter dem Warenkorb-Knopf, PC links unter den Bildern.
   Beschreibung mit Haekchen-Listen, Zwischenueberschriften und kurzen Absaetzen; Technik nach Gruppen mit Icon;
   Download als grosser Knopf. Ohne JavaScript stehen alle Bereiche als Klappboxen untereinander.
   Varianten (Tagbau 121, Sebastian 11.10.2026: "Wenn jemand 55 anklickt, steht oben bei 32"): Kacheln, Technik und Datenblatt kommen bei
   Produkten mit Variantendaten (snippets/mib-variantendaten.liquid) aus der GEWAEHLTEN Variante und wechseln beim Variantenwechsel mit.
   Ohne Variantendaten: groessenabhaengige Kacheln (Bildgroesse, Aufloesung, Helligkeit, Touch, Gewicht) bei mehreren Ausfuehrungen gar nicht. */
(function () {
  var NAME = { text: 'Produktbeschreibung', technik: 'Technik', downloads: 'Download' };
  var KURZ = { text: 'Beschreibung', technik: 'Technik', downloads: 'Download' };

  /* eigene Icons (24x24, Strich in Themefarbe) */
  var PFAD = {
    groesse: '<rect x="2.5" y="4" width="19" height="13" rx="1.5"/><path d="M8 21h8M12 17v4M7.5 13.5l9-6M16.5 7.5h-3.2M16.5 7.5v3.2M7.5 13.5h3.2M7.5 13.5v-3.2"/>',
    aufloesung: '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18"/>',
    helligkeit: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"/>',
    touch: '<path d="M9 11.5V5a1.5 1.5 0 0 1 3 0v6m0-1a1.5 1.5 0 0 1 3 0v1.5m0-.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.7a6 6 0 0 1-4.6-2.2l-2.4-3a1.6 1.6 0 0 1 2.5-2L9 15.5"/>',
    betrieb: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>',
    ausrichtung: '<rect x="3" y="3" width="8" height="13" rx="1.5"/><rect x="12" y="13" width="9.5" height="7" rx="1.5"/><path d="M14 4.5a5 5 0 0 1 5 5M19 9.5l1.6-1.9M19 9.5l-2.2-1"/>',
    schutz: '<path d="M12 2.5l7.5 3v6c0 4.6-3.1 8.3-7.5 10-4.4-1.7-7.5-5.4-7.5-10v-6z"/><path d="M12 8.5c1.6 2 2.6 3.4 2.6 4.6a2.6 2.6 0 0 1-5.2 0c0-1.2 1-2.6 2.6-4.6z"/>',
    gewicht: '<path d="M6.5 9h11L20 20.5H4z"/><circle cx="12" cy="6" r="2.5"/>',
    bild: '<rect x="2.5" y="4" width="19" height="13" rx="1.5"/><path d="M8 21h8M12 17v4"/>',
    anschluesse: '<path d="M9 3v4M15 3v4M7 7h10v4a5 5 0 0 1-10 0zM12 16v5"/>',
    masse: '<rect x="2" y="8" width="20" height="8" rx="1.5"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/>',
    strom: '<path d="M13 2L4.5 13.5H11L10 22l8.5-11.5H12z"/>',
    system: '<rect x="6" y="6" width="12" height="12" rx="1.5"/><rect x="9.5" y="9.5" width="5" height="5"/><path d="M9 2.5V6M15 2.5V6M9 18v3.5M15 18v3.5M2.5 9H6M2.5 15H6M18 9h3.5M18 15h3.5"/>',
    audio: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>',
    lieferumfang: '<path d="M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5L12 12l8.5-4.5M12 12v9"/>',
    allgemein: '<path d="M3 12.5V4a1 1 0 0 1 1-1h8.5l8.5 8.5-8.5 8.5z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5.5M12 7.6v.1"/>'
  };
  function icon(art, groesse) {
    return '<svg class="mib-icon" viewBox="0 0 24 24" width="' + groesse + '" height="' + groesse + '" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (PFAD[art] || PFAD.info) + '</svg>';
  }

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function leer(el) {
    return !el || (el.textContent.replace(/\s+/g, '').length < 3 && !el.querySelector('img, table, iframe, video'));
  }
  function ganzFett(el) {
    var f = el.querySelector('strong, b');
    return !!f && norm(f.textContent) === norm(el.textContent);
  }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* Satzenden (Index hinter dem Punkt); Abkuerzungen, Einzelbuchstaben und Zahlen zaehlen nicht */
  var ABK = /^(z|b|d|h|u|a|s|o|v|ca|bzw|inkl|zzgl|ggf|evtl|max|min|nr|st|std|mio|mrd|bspw|usw|etc|vgl|fa|hr|dr|abb|art|techn|sog|mind|tel|ggü|gem|lt|bzgl|zb|ua|dh)$/i;
  function satzEnden(t) {
    var r = /[.!?](?=\s|$)/g, m, enden = [];
    while ((m = r.exec(t))) {
      var vor = t.slice(0, m.index).match(/(\S+)$/), wort = vor ? vor[1].replace(/^[(„"']+/, '') : '';
      if (m[0] === '.' && (ABK.test(wort) || /^\S$/.test(wort) || /^[\d.,]+$/.test(wort))) continue;
      var nach = t.slice(m.index + 1).match(/^\s*(\S)/);
      if (nach && !/[A-ZÄÖÜ0-9„"(]/.test(nach[1])) continue;
      enden.push(m.index + 1);
    }
    return enden;
  }

  /* Textposition (in textContent) -> Textknoten + Versatz */
  function stelle(el, pos) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, rest = pos;
    while ((n = w.nextNode())) { if (rest <= n.data.length) return { n: n, o: rest }; rest -= n.data.length; }
    return null;
  }
  /* alles vor pos aus el herausloesen (Inline-Formatierung bleibt auf beiden Seiten erhalten) */
  function abschneiden(el, pos) {
    var s = stelle(el, pos);
    if (!s) return null;
    var r = document.createRange();
    r.setStart(el, 0); r.setEnd(s.n, s.o);
    var teil = r.extractContents();
    var erster = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null).nextNode();
    if (erster) erster.data = erster.data.replace(/^\s+/, '');
    return teil;
  }

  function technikTeilen(box) {
    var text = box.querySelector('.mib-details__text'), daten = box.querySelector('.mib-details__daten');
    if (!text || !daten) return;
    var kopf = null, kandidaten = text.querySelectorAll('p, h2, h3, h4, strong, b');
    for (var i = 0; i < kandidaten.length; i++) {
      if (/^\s*technische daten\s*:?\s*$/i.test(kandidaten[i].textContent)) { kopf = kandidaten[i]; break; }
    }
    if (kopf) {                       /* Kompaktformat: alles ab "Technische Daten" in den Reiter Technik (auch aus Wrapper-divs heraus) */
      while (kopf.parentNode !== text && kopf.parentNode.textContent.trim() === kopf.textContent.trim()) kopf = kopf.parentNode;
      var nach = [], knoten = kopf;
      while (knoten && knoten !== text) {
        for (var s = knoten.nextSibling; s; s = s.nextSibling) nach.push(s);
        knoten = knoten.parentNode;
      }
      kopf.parentNode.removeChild(kopf);
      for (var k = 0; k < nach.length; k++) daten.appendChild(nach[k]);
    } else {                          /* aeltere Texte: Datentabellen in den Reiter Technik */
      var tabellen = text.querySelectorAll('table');
      for (var t = 0; t < tabellen.length; t++) daten.appendChild(tabellen[t]);
    }
    if (daten.textContent.replace(/\s+/g, '').length > 20) box.querySelector('.mib-details__technik').hidden = false;
  }

  /* Einleitung = fette Kopfzeile + erster Satz des ersten Absatzes (max. ~200 Zeichen); der Rest bleibt im Reiter */
  function einleitung(box) {
    var text = box.querySelector('.mib-details__text');
    if (!text) return null;
    var wurzel = text;
    while (wurzel.children.length === 1 && wurzel.firstElementChild.tagName === 'DIV') wurzel = wurzel.firstElementChild;
    var schlicht = function (el) { return el && el.tagName === 'P' && !el.querySelector('br, img, table, ul, ol') && !/^technische daten\s*:?$/i.test(norm(el.textContent)); };
    var el = wurzel.firstElementChild, kopf = null, satzP = null, ende = 0;
    if (!schlicht(el)) return null;
    if (ganzFett(el)) { kopf = el; el = el.nextElementSibling; }
    if (schlicht(el) && !ganzFett(el) && norm(el.textContent)) {
      var roh = el.textContent, enden = satzEnden(roh);
      ende = enden.length ? enden[0] : roh.replace(/\s+$/, '').length;
      if (norm(roh.slice(0, ende)).length <= 200) satzP = el;
    }
    if (kopf && norm(kopf.textContent).length < 15) kopf = null;
    if (!satzP && !kopf) return null;
    if (!kopf && norm(satzP.textContent.slice(0, ende)).length < 60) return null;
    var div = document.createElement('div');
    div.className = 'mib-einleitung prose';
    if (kopf) { kopf.classList.add('mib-einleitung__kopf'); div.appendChild(kopf); }
    if (satzP) {
      if (norm(satzP.textContent.slice(ende)) === '') div.appendChild(satzP);
      else { var p = document.createElement('p'); p.appendChild(abschneiden(satzP, ende)); div.appendChild(p); }
    }
    return div;
  }

  function einleitungSetzen(box, div) {
    var produkt = box.closest('.product') || document;
    var alt = produkt.querySelectorAll('.mib-einleitung');
    for (var a = 0; a < alt.length; a++) alt[a].parentNode.removeChild(alt[a]);   /* Rest von vor einem Variantenwechsel */
    var info = box.closest('.product-info') || produkt;
    var titel = info.querySelector('[data-block-type="title"]');
    if (titel) titel.insertAdjacentElement('afterend', div); else box.insertAdjacentElement('beforebegin', div);
  }

  /* ---------- "Auf einen Blick": Eckdaten aus dem Beschreibungstext ---------- */

  /* Text in Zeilen zerlegen (Absatz, Listenpunkt, <br>, Tabellenzeile); fetter Zeilenanfang bzw. "Name:" = Bezeichnung */
  var BLOCK = /^(P|DIV|LI|UL|OL|H[1-6]|TABLE|TBODY|THEAD|TFOOT|SECTION|ARTICLE|BLOCKQUOTE|DL|DT|DD|HEADER|FOOTER)$/;
  function zeilen(wurzel) {
    var out = [], akt = { text: '', fett: null };
    function schliessen() {
      var t = norm(akt.text);
      if (t) {
        var z = { text: t, label: '', wert: t }, f = akt.fett ? norm(akt.fett) : '';
        if (f && t.indexOf(f) === 0 && /^[\s:]/.test(t.slice(f.length)) && !/\d$/.test(f) && norm(t.slice(f.length).replace(/^\s*:/, ''))) { z.label = f.replace(/:$/, ''); z.wert = norm(t.slice(f.length).replace(/^\s*:/, '')); }
        else { var m = t.match(/^([^:]{2,50}):\s*(\S.*)$/); if (m) { z.label = norm(m[1]); z.wert = m[2]; } }
        out.push(z);
      }
      akt = { text: '', fett: null };
    }
    function gehe(n) {
      for (var c = n.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) { akt.text += c.data; continue; }
        if (c.nodeType !== 1) continue;
        var tag = c.tagName;
        if (tag === 'BR') { schliessen(); continue; }
        if (tag === 'SCRIPT' || tag === 'STYLE') continue;
        if (tag === 'TR') {
          schliessen();
          var zellen = [];
          for (var i = 0; i < c.children.length; i++) zellen.push(norm(c.children[i].textContent));
          zellen = zellen.filter(function (x) { return x; });
          if (zellen.length >= 2) out.push({ text: zellen.join(': '), label: zellen[0].replace(/:$/, ''), wert: zellen.slice(1).join(' ') });
          else if (zellen.length === 1) out.push({ text: zellen[0], label: '', wert: zellen[0] });
          continue;
        }
        var block = BLOCK.test(tag);
        if (block) schliessen();
        if ((tag === 'STRONG' || tag === 'B') && !norm(akt.text) && akt.fett === null) akt.fett = c.textContent;
        gehe(c);
        if (block) schliessen();
      }
    }
    gehe(wurzel); schliessen();
    return out;
  }

  function vorZiffer(s, i) { return /\d\s$/.test(s.slice(Math.max(0, i - 2), i)); }
  function zahl(s) { return parseFloat(String(s).replace(/\.(?=\d{3}\b)/g, '').replace(',', '.')); }
  function deZahl(x) {
    var t = (Math.round(x * 10) / 10).toString().split('.');
    return t[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (t[1] ? ',' + t[1] : '');
  }
  /* alle Werte gleich -> der Wert, sonst null (widerspruechlich = keine Kachel) */
  function einig(liste) {
    if (!liste.length) return null;
    for (var i = 1; i < liste.length; i++) if (liste[i] !== liste[0]) return null;
    return liste[0];
  }
  var UNSICHER = /\boder\b|je nach|abhängig|optional|variante|wahlweise|\bbis\b.*\bje\b/i;
  var ZOLL = /(\d{1,3}(?:[.,]\d{1,2})?)\s*(?:"|″|”|“|''|’’|-?zoll\b|inch\b)/gi;
  var BEREICH_ZOLL = /\d\s*(?:"|″|”|“|''|zoll)?\s*(?:-|–|bis)\s*\d{1,3}(?:[.,]\d)?\s*(?:"|″|”|“|''|zoll)/i;

  function eckdaten(quelle, titel) {
    var zz = zeilen(quelle), alles = zz.map(function (z) { return z.text; }).join(' \n ');
    var k = {}, m, i;

    /* Bildgroesse: nur aus Zeilen "Groesse/Diagonale/Bild/Display", mit dem Titel abgeglichen */
    var gr = [], grUnsicher = false;
    zz.forEach(function (z) {
      var l = z.label.toLowerCase();
      if (!/größe|groesse|diagonale|zoll|bildschirm|^bild$|^display$|panel|bild\s*\/|^lcd$/.test(l) || /vesa|halter|verpackung|gehäuse|pixel|punkt|schrift/.test(l)) return;
      var w = z.wert, funde = [];
      ZOLL.lastIndex = 0;
      while ((m = ZOLL.exec(w))) { var x = zahl(m[1]); if (vorZiffer(w, m.index)) grUnsicher = true; if (x >= 7 && x <= 250) funde.push(x); }
      if (!funde.length) return;
      if (BEREICH_ZOLL.test(w) || UNSICHER.test(w)) grUnsicher = true;
      funde.forEach(function (x) { gr.push(x); });
    });
    if (gr.length && !grUnsicher) {
      var g0 = gr[0];
      if (gr.every(function (x) { return Math.abs(x - g0) < 0.05; })) {
        var tz = [], tt = titel || '';
        ZOLL.lastIndex = 0;
        if (!ZOLL.test(tt) && zz.length) tt = zz[0].text;          /* Titel ohne Zoll -> Kopfzeile des Textes */
        ZOLL.lastIndex = 0;
        while ((m = ZOLL.exec(tt))) tz.push(zahl(m[1]));
        var tEinig = einig(tz.map(String));
        if (!tz.length) k.groesse = deZahl(g0) + ' Zoll';
        else if (tEinig !== null && !BEREICH_ZOLL.test(tt) && Math.abs(zahl(tEinig) - g0) <= 1) k.groesse = deZahl(zahl(tEinig)) + ' Zoll';
      }
    }

    /* Aufloesung: nur aus Zeilen "Aufloesung/Bild/Display/Pixel" */
    var au = [], auUnsicher = false, RES = /(\d[\d.]{2,5})\s*[x×*]\s*(\d[\d.]{2,5})(?!\s*(?:mm|cm|m)\b)/g;
    zz.forEach(function (z) {
      var l = z.label.toLowerCase();
      if (!/auflösung|aufloesung|resolution|pixel|^bild$|bildschirm|^display$|panel|bild\s*\/|^lcd$/.test(l) || /vesa|halter|anschl|eingang|ausgang|hdmi|kamera/.test(l)) return;
      RES.lastIndex = 0;
      while ((m = RES.exec(z.wert))) {
        var a = parseInt(m[1].replace(/\./g, ''), 10), b = parseInt(m[2].replace(/\./g, ''), 10);
        if (a < 320 || b < 240 || a > 16000 || b > 16000) continue;
        if (UNSICHER.test(z.wert)) auUnsicher = true;
        au.push(Math.max(a, b) + 'x' + Math.min(a, b));
      }
    });
    var res = auUnsicher ? null : einig(au);
    if (res) {
      var NAMEN = { '7680x4320': '8K', '5120x2880': '5K', '5120x2160': '5K', '4096x2160': '4K', '3840x2160': '4K', '2560x1440': 'QHD', '1920x1080': 'Full HD', '1920x1200': 'WUXGA', '1366x768': 'HD', '1360x768': 'HD', '1280x720': 'HD' };
      k.aufloesung = NAMEN[res] || res.replace('x', ' × ');
    }

    /* Helligkeit: jede Angabe im ganzen Text muss gleich sein, Bereiche ("400-500 cd/m²") = unsicher */
    var HELL = /(\d{1,2}\.\d{3}|\d{2,5})\s*(?:cd\s*\/\s*m(?:²|2|\^2)|nits?\b|candela)/gi, he = [], heUnsicher = false;
    var HELL2 = /(?:cd\s*\/\s*m(?:²|2|\^2)|nits)\s*[\])]?\s*:?\s*(\d{1,2}\.\d{3}|\d{2,5})(?![\d,.]*\s*(?:x|×|:|mm|cm|%))/gi;
    if (!/\d\s*(?:-|–|bis)\s*\d[\d.]*\s*(?:cd|nits)/i.test(alles)) {
      while ((m = HELL.exec(alles))) { if (vorZiffer(alles, m.index)) heUnsicher = true; he.push(String(zahl(m[1]))); }
      while ((m = HELL2.exec(alles))) he.push(String(zahl(m[1])));
      var h = heUnsicher ? null : einig(he);
      if (h && zahl(h) >= 100 && zahl(h) <= 10000) k.helligkeit = deZahl(zahl(h)) + ' cd/m²';
    }

    /* Touch: Zahl der Beruehrungspunkte, nur eindeutig */
    if (!/kein(?:en)?\s+touch|ohne\s+[\w-]{0,12}\s*-?\s*(?:dual-?|multi-?)?touch|optional\w*\s+(?:mit\s+)?touch|touch\w*\s+optional/i.test(alles)) {
      var to = [], TOUCH = [/(\d{1,2})\s*-?\s*(?:punkt|punkte|pkt\.?|finger)\s*-?\s*(?:multi\s*-?\s*)?touch/gi,
        /(\d{1,2})\s*(?:gleichzeitige\s+|simultane\s+)?(?:berührungs|touch-?\s?)punkte?\w*/gi, /(\d{1,2})\s*(?:simultane\s+)?touch\s*-?points?/gi];
      TOUCH.forEach(function (r) { r.lastIndex = 0; while ((m = r.exec(alles))) to.push(m[1]); });
      zz.forEach(function (z) { if (/touch/i.test(z.label)) { var r = /(\d{1,2})\s*(?:punkte|punkt)\b/gi; while ((m = r.exec(z.wert))) to.push(m[1]); } });
      var tp = einig(to);
      if (tp && +tp >= 2 && +tp <= 100) k.touch = tp + ' Punkte';
    }

    /* IP-Schutz: eine Schutzart im ganzen Text, sonst die ausdruecklich frontseitige */
    var ip = [], IP = /\bIP\s?-?([56]\d)\b/g;
    while ((m = IP.exec(alles))) ip.push(m[1]);
    var ipw = einig(ip), ipWort = null;
    var fr = [], FR = /front\w*\s*:?\s*IP\s?([56]\d)|IP\s?([56]\d)\s*\(?\s*(?:front|frontseitig)/gi;
    while ((m = FR.exec(alles))) fr.push(m[1] || m[2]);
    if (!ipw && ip.length) { ipw = einig(fr); ipWort = 'Front'; }
    else if (ipw && fr.length && einig(fr) === ipw) ipWort = 'Front';
    if (ipw) k.schutz = { wert: 'IP' + ipw, wort: ipWort || (+ipw >= 65 && /outdoor|außen|aussen/i.test((titel || '') + ' ' + alles) ? 'Outdoor' : 'Schutzklasse') };

    /* Betriebszeit 24/7, 18/7 ... (Service-Zeiten zaehlen nicht) */
    var be = [], BE = /(^|[^\d\/])(24|20|18|16|12)\s*(?:h|std\.?)?\s*\/\s*7(?![\d\/])/gi;
    while ((m = BE.exec(alles))) {
      if (/support|service|hotline|erreichbar|kundendienst|beratung/i.test(alles.slice(Math.max(0, m.index - 30), m.index))) continue;
      be.push(m[2]);
    }
    var bz = einig(be);
    if (bz) k.betrieb = { wert: bz + '/7', wort: bz === '24' ? 'Dauerbetrieb' : 'Betriebszeit' };

    /* Ausrichtung */
    var HQ = /hoch(?:format)?\s*-?\s*(?:und|&|\/|oder|sowie|\+)\s*quer(?:format)?|quer(?:format)?\s*-?\s*(?:und|&|\/|oder|sowie|\+)\s*hoch(?:format)?|portrait\s*(?:und|&|\/|oder|and|or|\+)\s*landscape|landscape\s*(?:und|&|\/|oder|and|or|\+)\s*portrait/i;
    var nurQ = /nur\s+(?:im\s+)?querformat|nicht\s+(?:für\s+)?(?:das\s+|den\s+)?hochformat|landscape\s+only|nur\s+landscape/i;
    var nurH = /nur\s+(?:im\s+)?hochformat|portrait\s+only|nur\s+portrait/i;
    var aus = [];
    if (HQ.test(alles)) aus.push('Hoch + Quer');
    if (nurQ.test(alles)) aus.push('Quer');
    if (nurH.test(alles)) aus.push('Hoch');
    zz.forEach(function (z) {
      if (!/ausrichtung|orientierung/i.test(z.label) || HQ.test(z.wert)) return;
      if (/^(?:nur\s+)?(?:querformat|landscape|quer)$/i.test(z.wert)) aus.push('Quer');
      if (/^(?:nur\s+)?(?:hochformat|portrait|hoch)$/i.test(z.wert)) aus.push('Hoch');
    });
    var ar = einig(aus);
    if (ar) k.ausrichtung = ar;

    /* Gewicht: nur Zeilen "Gewicht" bzw. Abschnitt Masse; Verpackung/Traglast/je nach Groesse = nicht */
    var ge = [], geUnsicher = false, KG = /(\d{1,3}(?:[.,]\d{1,2})?)\s*kg\b/gi, WEG = /verpack|brutto|versand|traglast|belast|tragkraft|max|gross|paket|karton|bis\s+zu|je nach|ca\.|mit\s+fu|mit\s+stand/i;
    zz.forEach(function (z) {
      var l = z.label.toLowerCase(), teile = [];
      if (/gewicht|weight/.test(l)) { if (!WEG.test(l)) teile = [z.wert]; }
      else if (/^(maße|masse|abmessung|abmessungen|mechanik|mechanisch|maße\s*(?:&|und)\s*gewicht)$/.test(l)) teile = z.wert.split(/\s+·\s+|;\s*/).filter(function (s) { return /kg\b/i.test(s); });
      teile.forEach(function (s) {
        if (WEG.test(s) || UNSICHER.test(s)) { geUnsicher = true; return; }
        KG.lastIndex = 0; var f = [];
        while ((m = KG.exec(s))) { if (vorZiffer(s, m.index)) geUnsicher = true; f.push(String(zahl(m[1]))); }
        if (f.length > 1 && !einig(f)) geUnsicher = true;
        if (f.length) ge.push(f[0]);
      });
    });
    var gw = geUnsicher ? null : einig(ge);
    if (gw && zahl(gw) > 0) k.gewicht = deZahl(zahl(gw)) + ' kg';

    var REIHE = [
      ['groesse', 'Bildgröße'], ['aufloesung', 'Auflösung'], ['helligkeit', 'Helligkeit'], ['touch', 'Touch'],
      ['schutz', null], ['betrieb', null], ['ausrichtung', 'Ausrichtung'], ['gewicht', 'Gewicht']
    ], kacheln = [];
    for (i = 0; i < REIHE.length && kacheln.length < 6; i++) {
      var v = k[REIHE[i][0]];
      if (!v) continue;
      kacheln.push({ art: REIHE[i][0], wert: typeof v === 'string' ? v : v.wert, wort: typeof v === 'string' ? REIHE[i][1] : v.wort });
    }
    return kacheln;
  }

  function blickBauen(kacheln) {
    if (kacheln.length < 3) return null;
    var div = document.createElement('div');
    div.className = 'mib-blick mib-blick--' + kacheln.length;
    var html = '<p class="mib-blick__titel">Auf einen Blick</p><ul class="mib-blick__liste" role="list">';
    kacheln.forEach(function (x) {
      var m = x.wert.match(/^([\d.,]+)\s+(\S.*)$/);       /* "450 cd/m²" -> Zahl gross, Einheit klein */
      var wert = m ? '<span class="mib-blick__zahl">' + esc(m[1]) + '</span> <span class="mib-blick__einheit">' + esc(m[2]) + '</span>' : esc(x.wert);
      html += '<li class="mib-blick__kachel mib-blick__kachel--' + x.art + '">' + icon(x.art, 30) +
        '<span class="mib-blick__wert">' + wert + '</span><span class="mib-blick__wort">' + esc(x.wort) + '</span></li>';
    });
    div.innerHTML = html + '</ul>';
    return div;
  }

  /* ---------- Variantendaten (Tagbau 121): Kacheln, Technik, Datenblatt je gewaehlter Variante ---------- */
  var VD_ART = ['groesse', 'aufloesung', 'helligkeit', 'touch', 'schutz', 'betrieb', 'ausrichtung', 'gewicht'];
  var VD_WORT = { groesse: 'Bildgröße', aufloesung: 'Auflösung', helligkeit: 'Helligkeit', touch: 'Touch', ausrichtung: 'Ausrichtung', gewicht: 'Gewicht' };
  var JE_GROESSE = { groesse: 1, aufloesung: 1, helligkeit: 1, touch: 1, gewicht: 1 };
  var vdCache, letzteVariante = null;
  function vd() {
    if (vdCache !== undefined) return vdCache;
    var el = document.getElementById('mib-variantendaten');
    try { vdCache = el ? JSON.parse(el.textContent) : null; } catch (e) { vdCache = null; }
    if (vdCache && (!vdCache.varianten || typeof vdCache.varianten !== 'object')) vdCache = null;
    if (vdCache) vdCache.start = el.getAttribute('data-start');
    return vdCache;
  }
  function varianteId() {
    var d = vd(), i, m;
    if (!d) return null;
    if (letzteVariante && d.varianten[letzteVariante]) return letzteVariante;
    var felder = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');   /* Produktformular (Impact haelt es aktuell) */
    for (i = 0; i < felder.length; i++) if (d.varianten[felder[i].value]) return String(felder[i].value);
    m = location.search.match(/[?&]variant=(\d+)/);
    if (m && d.varianten[m[1]]) return m[1];
    return d.varianten[d.start] ? d.start : null;
  }
  function mehrereAusfuehrungen(d) {            /* Option ausser Farbe mit mind. 2 Werten -> Produkttext beschreibt evtl. nur eine Ausfuehrung */
    return !!(d && d.optionen && d.optionen.some(function (o) { return o.werte && o.werte.length >= 2 && !/farbe|colou?r/i.test(o.name || ''); }));
  }
  function kachelnAusDaten(e) {
    var out = [];
    VD_ART.forEach(function (art) {
      var v = e && e[art];
      if (!v || out.length >= 6) return;
      if (typeof v === 'string') out.push({ art: art, wert: v, wort: VD_WORT[art] });
      else if (v.wert) out.push({ art: art, wert: String(v.wert), wort: v.wort || VD_WORT[art] || '' });
    });
    return out;
  }
  /* Groessen im Dateinamen ("Datenblatt ... - 55 Zoll", '55"', "1,8 mm") bzw. am Anfang eines Optionswerts ("55", '32"', "1,8mm") */
  function dateiGroessen(t) {
    var r = /(\d{1,3}(?:[.,]\d)?)\s*(?:zoll|"|″|mm)(?![a-zäöü])/gi, m, out = [];
    while ((m = r.exec(t || ''))) out.push(m[1].replace('.', ','));
    return out;
  }
  /* Betriebszeit-Werte ("24/7", "18/7") sind keine Groesse, sondern ein Wort (Tagbau 125, neues AIO-Buendel 11.10.2026) */
  function betriebszeit(w) { return /^\s*\d{1,2}\s*\/\s*\d{1,2}\s*$/.test(String(w)); }
  function betriebszeitIn(name, w) {            /* exakt "24/7" im Dateinamen (Leerzeichen um den Schraegstrich erlaubt, keine Nachbarziffer) */
    var t = String(w).replace(/\s+/g, '').split('/');
    return new RegExp('(^|[^0-9])' + t[0] + '\\s*/\\s*' + t[1] + '(?![0-9])').test(name || '');
  }
  function optionGroessen(werte) {
    var out = [];
    (werte || []).forEach(function (w) { if (betriebszeit(w)) return; var m = String(w).match(/^\s*(\d{1,3}(?:[.,]\d)?)/); if (m) out.push(m[1].replace('.', ',')); });
    return out;
  }
  /* Optionswerte ohne Zahl (Farbe, Touch, Ausrichtung …), die im Dateinamen stehen, muessen zur Variante passen ("… schwarz") */
  function wortPasst(name, d, v) {
    var n = ' ' + (name || '').toLowerCase().replace(/[^a-z0-9äöüß,]+/g, ' ') + ' ';
    return (d.optionen || []).every(function (o, i) {
      var da = (o.werte || []).filter(function (w) { return betriebszeit(w) ? betriebszeitIn(name, w) : !/^\s*\d/.test(w) && n.indexOf(' ' + String(w).toLowerCase().replace(/[^a-z0-9äöüß,]+/g, ' ').trim() + ' ') >= 0; });
      da = da.filter(function (w) { return !da.some(function (x) { return x !== w && x.toLowerCase().indexOf(w.toLowerCase()) >= 0; }); });   /* "ohne Touchscreen" schlaegt "Touchscreen" */
      return !da.length || (v && da.indexOf(v.optionen[i]) >= 0);
    });
  }
  /* Kacheln/Technik/Download auf die gewaehlte Variante setzen; true = etwas geaendert */
  function variantAnwenden(box) {
    var d = vd(), id = varianteId();
    if (box._vdGesetzt && box._vdId === id) return false;
    box._vdGesetzt = true; box._vdId = id;
    var v = d && id ? d.varianten[id] : null, mitDaten = !!(d && d.daten), k;
    var kacheln = box._kachelnText || [];
    if (mitDaten) kacheln = kachelnAusDaten(v && v.eckdaten);
    else if (mehrereAusfuehrungen(d)) kacheln = kacheln.filter(function (x) { return !JE_GROESSE[x.art]; });
    if (box._blick && box._blick.parentNode) box._blick.parentNode.removeChild(box._blick);
    box._blick = blickBauen(kacheln);
    var tech = box.querySelector('.mib-details__technik'), daten = box.querySelector('.mib-details__daten');
    if (tech && daten && mitDaten) {
      var irgendeine = false;
      for (k in d.varianten) if (d.varianten[k].technik) irgendeine = true;
      if (v && v.technik) { daten.innerHTML = v.technik; technikAufbereiten(daten); tech.hidden = false; }
      else if (irgendeine) { daten.innerHTML = ''; tech.hidden = true; }      /* Daten fehlen nur bei dieser Variante -> lieber nichts als Falsches */
      else { daten.innerHTML = box._technikText || ''; tech.hidden = !box._technikSichtbar; }
    }
    var punkte = box.querySelectorAll('.mib-downloads > li');
    if (d && punkte.length) {
      var eigene = optionGroessen(v ? v.optionen : []), alle = [], sichtbar = 0;
      for (k in d.varianten) alle = alle.concat(optionGroessen(d.varianten[k].optionen));
      for (var i = 0; i < punkte.length; i++) {
        var a = punkte[i].querySelector('.mib-download');
        var gr = dateiGroessen(a ? a.getAttribute('data-mib-alt') : '').filter(function (g) { return alle.indexOf(g) >= 0; });
        var zeigen = (!gr.length || gr.some(function (g) { return eigene.indexOf(g) >= 0; })) && wortPasst(a ? a.getAttribute('data-mib-alt') : '', d, v);
        punkte[i].hidden = !zeigen;
        if (zeigen) sichtbar++;
      }
      var dl = box.querySelector('.mib-details__downloads');
      if (dl) dl.hidden = !sichtbar;
    }
    return true;
  }

  /* ---------- Reiter Beschreibung: Haekchen-Listen, Zwischenueberschriften, kurze Absaetze ---------- */
  function textAufbereiten(text) {
    var i, el;
    /* Listen -> Haekchen; Listenpunkt "Name – Erklaerung" / "Name: Erklaerung" -> Name fett */
    var listen = text.querySelectorAll('ul');
    for (i = 0; i < listen.length; i++) if (!listen[i].closest('table')) listen[i].classList.add('mib-haken');
    var punkte = text.querySelectorAll('ul.mib-haken > li');
    for (i = 0; i < punkte.length; i++) {
      var li = punkte[i], erst = li.firstChild;
      while (erst && erst.nodeType === 3 && !erst.data.trim()) erst = erst.nextSibling;
      if (erst && erst.nodeType === 1 && erst.tagName === 'P') { erst = erst.firstChild; }
      if (!erst || erst.nodeType !== 3) continue;
      var m = erst.data.match(/^(\s*)([^–—:\d]{3,60}?)(\s+[–—-]\s+|:\s+)/);
      if (!m || /[.!?]/.test(m[2])) continue;
      var rest = erst.splitText(m[1].length + m[2].length + (m[3].charAt(0) === ':' ? 1 : 0));
      var f = document.createElement('strong');
      f.textContent = erst.data.replace(/^\s+/, '');
      erst.data = m[1];
      rest.parentNode.insertBefore(f, rest);
    }
    /* Zwischenueberschriften: kurze Zeilen ohne Satzende, fett / als Ueberschrift / vor einer Liste */
    var bloecke = text.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6');
    for (i = 0; i < bloecke.length; i++) {
      el = bloecke[i];
      if (el.closest('li, table') || el.querySelector('p, div, ul, ol, table, img, h1, h2, h3, h4')) continue;
      var t = norm(el.textContent), kopfTag = /^H[1-6]$/.test(el.tagName);
      if (t.length < 2 || t.length > (kopfTag ? 150 : 70) || /[.!?:,;]$/.test(t)) continue;
      var naechst = el.nextElementSibling;
      var einzeln = t.length <= 40 && t.split(' ').length <= 4 && !/\d/.test(t) && !el.querySelector('a');   /* z. B. "Eigenschaften" */
      if (kopfTag || ganzFett(el) || einzeln || (naechst && /^(UL|OL|TABLE)$/.test(naechst.tagName))) el.classList.add('mib-zwischen');
    }
    /* alte <br>-Texte: Zeile "Abschnitt" (kurz, ohne Doppelpunkt) fett, "Name: Wert" -> Name fett */
    var w = document.createTreeWalker(text, NodeFilter.SHOW_TEXT, null), knoten = [], n;
    while ((n = w.nextNode())) knoten.push(n);
    knoten.forEach(function (n) {
      var p = n.parentNode;
      if (!p || p.closest('li, table, a, strong, b, h1, h2, h3, h4, h5, h6')) return;
      var vor = n.previousSibling, nach = n.nextSibling;
      var zeilenStart = vor ? (vor.nodeType === 1 && vor.tagName === 'BR') : (p !== text && p.firstChild === n);
      if (!zeilenStart) return;
      var t = n.data, m2;
      if (nach && nach.nodeType === 1 && nach.tagName === 'BR' && vor && vor.nodeType === 1 && vor.tagName === 'BR' && (m2 = t.match(/^\s*([A-ZÄÖÜ][^:.!?\d]{1,38})\s*$/))) {
        var k = document.createElement('strong'); k.className = 'mib-zeilenkopf'; k.textContent = m2[1];
        p.replaceChild(k, n); return;
      }
      if ((m2 = t.match(/^(\s*)([A-ZÄÖÜa-zäöü][^:\n.!?]{1,40}:)\s+\S/)) && (nach === null || nach.nodeType !== 1 || nach.tagName === 'BR')) {
        var rest = n.splitText(m2[1].length + m2[2].length), f = document.createElement('strong');
        f.textContent = m2[2]; n.data = m2[1]; p.insertBefore(f, rest);
      }
    });
    /* lange Absaetze an Satzgrenzen teilen (Stuecke ab ~200 Zeichen) */
    var absaetze = text.querySelectorAll('p');
    for (i = 0; i < absaetze.length; i++) {
      el = absaetze[i];
      if (el.closest('li, table') || el.querySelector('br, ul, ol, table, img')) continue;
      var schutz = 0;
      while (norm(el.textContent).length > 380 && schutz++ < 8) {
        var roh = el.textContent, gesamt = roh.length, enden = satzEnden(roh), schnitt = 0;
        for (var e = 0; e < enden.length; e++) if (enden[e] >= 200 && gesamt - enden[e] >= 120) { schnitt = enden[e]; break; }
        if (!schnitt) break;
        var neu = document.createElement('p');
        neu.appendChild(abschneiden(el, schnitt));
        el.parentNode.insertBefore(neu, el);
      }
    }
    /* lange Textstuecke in <br>-Texten: Absatzluecke an Satzgrenzen einfuegen */
    w = document.createTreeWalker(text, NodeFilter.SHOW_TEXT, null); knoten = [];
    while ((n = w.nextNode())) if (n.data.length > 420 && !n.parentNode.closest('li, table, a') && n.parentNode.tagName !== 'P') knoten.push(n);
    knoten.forEach(function (n) {
      var enden = satzEnden(n.data), schnitte = [], letzter = 0;
      enden.forEach(function (e) { if (e - letzter >= 200 && n.data.length - e >= 120) { schnitte.push(e); letzter = e; } });
      for (var s = schnitte.length - 1; s >= 0; s--) {
        var zweiter = n.splitText(schnitte[s]);
        zweiter.data = zweiter.data.replace(/^\s+/, '');
        var luecke = document.createElement('span'); luecke.className = 'mib-absatz'; luecke.setAttribute('aria-hidden', 'true');
        zweiter.parentNode.insertBefore(luecke, zweiter);
      }
    });
  }

  /* ---------- Reiter Technik: Gruppen mit Icon, Zebra-Zeilen ---------- */
  var GRUPPEN = [
    ['allgemein', 'Allgemein'], ['bild', 'Bild'], ['touch', 'Touch'], ['anschluesse', 'Anschlüsse'], ['system', 'System'],
    ['audio', 'Audio'], ['masse', 'Maße & Gewicht'], ['betrieb', 'Betrieb'], ['strom', 'Strom'], ['lieferumfang', 'Lieferumfang'], ['info', 'Weitere Daten']
  ];
  function kategorie(label) {
    var l = (label || '').toLowerCase();
    if (/lieferumfang|zubehör|enthalten/.test(l)) return 'lieferumfang';
    if (/touch|stift|berühr/.test(l)) return 'touch';
    if (/betriebssystem|system|software|android|windows|prozessor|cpu|gpu|soc|speicher|ram\b|rom\b|player|kiosk|cms|app/.test(l)) return 'system';
    if (/audio|lautsprecher|sound|mikrofon|^ton/.test(l)) return 'audio';
    if (/anschl|schnittstelle|eingang|ausgang|konnektiv|connect|hdmi|usb|lan\b|netzwerk|wlan|wifi|bluetooth|port|steuerung|rs-?232|i\/o/.test(l)) return 'anschluesse';
    if (/strom|leistung|verbrauch|energie|spannung|netz|power|watt|standby|effizienz|netzteil/.test(l)) return 'strom';
    if (/betrieb|temperatur|feucht|umgebung|lebensdauer|mtbf|schutz|^ip|laufzeit|kühl|lüfter/.test(l)) return 'betrieb';
    if (/maß|mass|abmess|gewicht|vesa|gehäuse|rahmen|tiefe|breite|höhe|montage|halter|mechani|farbe|material|glas|größe/.test(l) && !/bildschirm|display|diagonale/.test(l)) return 'masse';
    if (/bild|display|anzeige|panel|helligkeit|kontrast|auflösung|winkel|farb|beleucht|reaktion|haze|seitenverh|pixel|diagonale|größe|sensor|lcd|led/.test(l)) return 'bild';
    if (/modell|artikel|produkt|hersteller|ean|garantie|serie|typ|marke|einsatz|zertifi|allgemein/.test(l)) return 'allgemein';
    return 'info';
  }
  function gruppeHtml(art, name, zeilen) {
    var h = '<section class="mib-technik__gruppe"><div class="mib-technik__kopf" role="heading" aria-level="3"><span class="mib-technik__icon">' + icon(art, 20) + '</span>' + esc(name) + '</div><dl class="mib-technik__zeilen">';
    zeilen.forEach(function (z) {
      h += z.label ? '<div class="mib-technik__zeile"><dt>' + esc(z.label) + '</dt><dd>' + esc(z.wert) + '</dd></div>'
        : '<div class="mib-technik__zeile mib-technik__zeile--ohne"><dd>' + esc(z.wert) + '</dd></div>';
    });
    return h + '</dl></section>';
  }
  function technikAufbereiten(daten) {
    var i, j;
    /* Kompaktformat: Liste "<strong>Bild:</strong> a · b · c" -> je Listenpunkt eine Gruppe */
    var listen = daten.querySelectorAll('ul');
    for (i = 0; i < listen.length; i++) {
      var ul = listen[i], punkte = ul.querySelectorAll(':scope > li'), gruppen = [], treffer = 0;
      for (j = 0; j < punkte.length; j++) {
        var f = punkte[j].querySelector('strong, b'), t = norm(punkte[j].textContent);
        var lab = f ? norm(f.textContent).replace(/:$/, '') : '';
        if (!f || !lab || t.indexOf(norm(f.textContent)) !== 0) { gruppen.push(null); continue; }
        treffer++;
        var rest = norm(t.slice(norm(f.textContent).length).replace(/^\s*:/, ''));
        var teile = rest.split(/\s+·\s+/).filter(function (s) { return s; });
        var art = kategorie(lab), name = lab;
        if (art === 'masse' && /^maße$/i.test(lab) && /\bkg\b/i.test(rest)) name = 'Maße & Gewicht';
        gruppen.push({ art: art, name: name, zeilen: teile.map(function (s) { return { label: '', wert: s }; }) });
      }
      if (!punkte.length || treffer / punkte.length < 0.6) continue;
      var div = document.createElement('div');
      div.className = 'mib-technik';
      div.innerHTML = gruppen.map(function (g, n) {
        return g ? gruppeHtml(g.art, g.name, g.zeilen) : gruppeHtml('info', 'Weitere Daten', [{ label: '', wert: norm(punkte[n].textContent) }]);
      }).join('');
      ul.parentNode.replaceChild(div, ul);
    }
    /* Tabellen: Kopfzeilen = Gruppen; ohne Kopfzeilen nach Bezeichnung einsortieren */
    var tabellen = daten.querySelectorAll('table');
    for (i = 0; i < tabellen.length; i++) {
      var tab = tabellen[i], reihen = tab.querySelectorAll('tr'), liste = [], hatKopf = false, akt = null;
      for (j = 0; j < reihen.length; j++) {
        var zellen = [];
        for (var c = 0; c < reihen[j].children.length; c++) { var z = norm(reihen[j].children[c].textContent); if (z) zellen.push(z); }
        if (!zellen.length) continue;
        if (zellen.length === 1) { hatKopf = true; akt = { art: kategorie(zellen[0]), name: zellen[0], zeilen: [] }; liste.push(akt); continue; }
        if (reihen[j].closest('thead') || (j === 0 && reihen[j].querySelectorAll('th').length === reihen[j].children.length)) continue;
        var zeile = { label: zellen[0].replace(/:$/, ''), wert: zellen.slice(1).join(' ') };
        if (!akt) { akt = { art: null, name: null, zeilen: [] }; liste.push(akt); }
        akt.zeilen.push(zeile);
      }
      var alleZeilen = 0;
      liste.forEach(function (g) { alleZeilen += g.zeilen.length; });
      if (alleZeilen < 2) continue;
      var html = '';
      if (hatKopf) {
        liste.forEach(function (g) { if (g.zeilen.length) html += gruppeHtml(g.art || 'info', g.name || 'Allgemein', g.zeilen); });
      } else {
        var sortiert = {};
        liste.forEach(function (g) { g.zeilen.forEach(function (z) { var a = kategorie(z.label); (sortiert[a] = sortiert[a] || []).push(z); }); });
        GRUPPEN.forEach(function (gr) { if (sortiert[gr[0]]) html += gruppeHtml(gr[0], gr[1], sortiert[gr[0]]); });
      }
      var neu = document.createElement('div');
      neu.className = 'mib-technik';
      neu.innerHTML = html;
      tab.parentNode.replaceChild(neu, tab);
    }
  }

  /* ---------- Reiter Download: grosser Knopf ---------- */
  function downloadsAufbereiten(box) {
    var links = box.querySelectorAll('.mib-download');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], name = a.querySelector('.mib-download__name'), meta = a.querySelector('.mib-download__meta');
      if (!name) continue;
      var alt = norm(name.textContent), typ = meta ? norm(meta.textContent).split(' ')[0] : 'PDF';
      if (!a.hasAttribute('data-mib-alt')) a.setAttribute('data-mib-alt', alt);   /* Groesse im Namen -> Datenblatt der Variante */
      a.classList.add('mib-download--gross');
      if (/datenblatt|datasheet|data sheet|spec/i.test(alt) || links.length === 1) {
        name.textContent = 'Datenblatt herunterladen';
        if (meta) meta.textContent = alt + ' · ' + typ;
      } else if (meta) meta.textContent = typ + ' · herunterladen';
    }
  }

  function waehlen(box, n) {
    var teile = box._teile;
    for (var i = 0; i < teile.length; i++) {
      var an = i === n;
      teile[i].knopf.setAttribute('aria-selected', an ? 'true' : 'false');
      teile[i].knopf.tabIndex = an ? 0 : -1;
      teile[i].d.classList.toggle('mib-aktiv', an);
      teile[i].d.open = true;
      teile[i].d.setAttribute('aria-expanded', 'true');
    }
  }

  function reiter(box) {
    var teile = [], details = box.querySelectorAll(':scope > details');
    for (var i = 0; i < details.length; i++) {
      var d = details[i];
      var art = d.classList.contains('mib-details__technik') ? 'technik' : d.classList.contains('mib-details__downloads') ? 'downloads' : 'text';
      if (art === 'text' && leer(d.querySelector('.mib-details__text'))) d.hidden = true;
      if (d.hidden) continue;
      teile.push({ art: art, d: d });
    }
    if (!teile.length) return;
    var leiste = document.createElement('div');
    leiste.className = 'mib-reiter';
    leiste.setAttribute('role', 'tablist');
    leiste.setAttribute('aria-label', 'Produktinformationen');
    teile.forEach(function (t, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mib-reiter__knopf';
      b.setAttribute('role', 'tab');
      b.id = box.id + '-reiter-' + t.art;
      t.d.id = box.id + '-bereich-' + t.art;
      b.setAttribute('aria-controls', t.d.id);
      t.d.setAttribute('role', 'tabpanel');
      t.d.setAttribute('aria-labelledby', b.id);
      b.innerHTML = '<span class="mib-reiter__lang">' + NAME[t.art] + '</span><span class="mib-reiter__kurz">' + KURZ[t.art] + '</span>';
      b.addEventListener('click', function () { waehlen(box, n); });
      b.addEventListener('keydown', function (e) {
        var z = e.key === 'ArrowRight' ? n + 1 : e.key === 'ArrowLeft' ? n - 1 : null;
        if (z === null) return;
        z = (z + teile.length) % teile.length;
        waehlen(box, z);
        teile[z].knopf.focus();
        e.preventDefault();
      });
      leiste.appendChild(b);
      t.knopf = b;
    });
    box.insertBefore(leiste, box.firstChild);
    box.classList.add('mib-details--reiter');
    box._teile = teile;
    waehlen(box, 0);
  }

  function aufbauen(box) {
    if (box.hasAttribute('data-geteilt')) return;
    box.setAttribute('data-geteilt', '');
    var text = box.querySelector('.mib-details__text');
    var quelle = text ? text.cloneNode(true) : null;               /* Eckdaten aus dem unveraenderten Text lesen */
    var intro = einleitung(box);
    technikTeilen(box);
    var daten = box.querySelector('.mib-details__daten');
    if (daten) technikAufbereiten(daten);
    var tech = box.querySelector('.mib-details__technik');
    box._technikText = daten ? daten.innerHTML : '';                 /* Technik aus dem Produkttext (Rueckfall) */
    box._technikSichtbar = !!(tech && !tech.hidden);
    if (text) textAufbereiten(text);
    downloadsAufbereiten(box);
    if (intro) einleitungSetzen(box, intro);
    var produkt = box.closest('.product') || document;
    var alt = produkt.querySelectorAll('.mib-blick');
    for (var a = 0; a < alt.length; a++) alt[a].parentNode.removeChild(alt[a]);   /* Rest von vor einem Variantenwechsel */
    var titel = produkt.querySelector('.product-info__title');
    box._kachelnText = quelle ? eckdaten(quelle, titel ? titel.textContent : '') : [];
    box._blick = null; box._vdGesetzt = false;
    variantAnwenden(box);
    reiter(box);
  }

  /* Reiterleiste neu, wenn sich beim Variantenwechsel ohne Neuaufbau die sichtbaren Bereiche aendern */
  function reiterNeu(box) {
    var vorher = null, leiste = box.querySelector(':scope > .mib-reiter');
    (box._teile || []).forEach(function (t) { if (t.knopf && t.knopf.getAttribute('aria-selected') === 'true') vorher = t.art; });
    if (leiste) leiste.parentNode.removeChild(leiste);
    var ds = box.querySelectorAll(':scope > details');
    for (var i = 0; i < ds.length; i++) ds[i].classList.remove('mib-aktiv');
    box._teile = null;
    reiter(box);
    (box._teile || []).forEach(function (t, n) { if (t.art === vorher) waehlen(box, n); });
  }

  function zweispaltig(produkt) {
    var cs = getComputedStyle(produkt);
    return cs.display === 'grid' && cs.gridTemplateColumns.trim().split(/\s+/).length >= 2;
  }

  /* Kacheln: PC unter Titel/Einleitung, Handy direkt unter dem Warenkorb-Knopf */
  function blickPlatzieren(box, breit) {
    var blick = box._blick;
    if (!blick) return;
    var info = box.closest('.product-info') || (box._heim && box._heim.closest('.product-info'));
    var produkt = box.closest('.product');
    if (!info && produkt) info = produkt.querySelector('.product-info');
    if (!info) return;
    var ziel;
    if (breit) ziel = info.querySelector('.mib-einleitung') || info.querySelector('[data-block-type="title"]');
    else ziel = info.querySelector('[data-block-type="buy-buttons"]');
    if (!ziel) ziel = info.querySelector('[data-block-type="title"]');
    if (ziel && ziel.nextElementSibling !== blick) ziel.insertAdjacentElement('afterend', blick);
    blick.classList.toggle('mib-blick--pc', !!breit);
  }

  function platzieren(box) {
    var produkt = box.closest('.product');
    var galerie = produkt && produkt.querySelector(':scope > product-gallery, :scope > .product-gallery');
    if (!box._heim && box.parentElement !== produkt) box._heim = box.parentElement;
    var breit = !!(produkt && zweispaltig(produkt));
    if (breit && galerie && box._heim) {             /* PC: in die linke Spalte unter die Bilder */
      if (box.parentElement !== produkt) {
        var alt = produkt.querySelectorAll(':scope > .mib-details');   /* Rest von vor einem Variantenwechsel */
        for (var a = 0; a < alt.length; a++) if (alt[a] !== box) alt[a].parentNode.removeChild(alt[a]);
        galerie.insertAdjacentElement('afterend', box);
        produkt.classList.add('mib-mit-details');
      }
    } else if (box._heim && box.parentElement !== box._heim) {   /* Handy: unter dem Warenkorb-Knopf */
      box._heim.appendChild(box);
      if (produkt) produkt.classList.remove('mib-mit-details');
    }
    blickPlatzieren(box, breit);
  }

  function lauf() {
    var boxen = document.querySelectorAll('.mib-details[data-mib-details]');
    for (var i = 0; i < boxen.length; i++) {
      if (boxen[i].hasAttribute('data-geteilt')) { if (variantAnwenden(boxen[i])) reiterNeu(boxen[i]); }
      else aufbauen(boxen[i]);
      platzieren(boxen[i]);
    }
  }

  if (window.MIB_TEST) { window.MIB_TEST = { eckdaten: eckdaten, zeilen: zeilen, satzEnden: satzEnden, kachelnAusDaten: kachelnAusDaten, dateiGroessen: dateiGroessen, optionGroessen: optionGroessen, wortPasst: wortPasst, betriebszeit: betriebszeit }; return; }
  var warte;
  function bald() { clearTimeout(warte); warte = setTimeout(lauf, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lauf); else lauf();
  window.addEventListener('resize', bald);
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && (e.detail.variant || e.detail.currentVariant);
    if (v && v.id) letzteVariante = String(v.id);
    bald();
  });
  /* Impact baut die Produktseite beim Variantenwechsel neu auf (product-rerender) -> neue Box wieder einsortieren */
  new MutationObserver(function () { if (document.querySelector('.mib-details[data-mib-details]:not([data-geteilt])')) bald(); })
    .observe(document.body, { childList: true, subtree: true });
})();
